import React from "react";
import { I18n } from "react-redux-i18n";
import cx from "classnames";

import { Flex } from "@common/components/Flex";
import { Search } from "@common/components/Search";
import { getTestAttributes } from "@common/utils/tests";
import { FolderPrimaryListDto } from "@common/dto/folder/primary-list-dto";

import { Folders } from "./components/folders";
import { Formats } from "./components/formats";
import { FormatFieldItem } from "./format-field-selector.types";

import "./format-field-selector.styles.scss";
import {FormatColumnKey} from "@common/components/format-field-selector/components/formats/formats.types";

type FormatFieldSelectorProps = {
  className?: string;
  classes?: {
    folders?: string;
    formats?: string;
    search?: string;
    searchForm?: string;
    formatsTableBody?: string;
  };
  withSearch?: boolean;
  searchKeyword?: string;
  onSearchKeyword?: (searchKeyword: string) => void;
  searchPlaceholder?: string;
  folders: FolderPrimaryListDto[];
  selectedFolder?: FolderPrimaryListDto;
  isFoldersLoading: boolean;
  onSelectedFolderChange: (folder: FolderPrimaryListDto) => void;
  formats: FormatFieldItem[];
  selectedFormat?: FormatFieldItem;
  isFormatsLoading: boolean;
  onSelectedFormatChange: (format: FormatFieldItem) => void;
  getId?: {
    // TODO not used
    searchIcon?: string;
    search?: string;
    folder: string;
  };
  moduleName: string;
  headerComponent?: React.ReactNode;
  showTableHeader?: boolean;
  tableColumns?: { label: string; field: FormatColumnKey.name }[]
};

export const FormatFieldSelector: React.FC<FormatFieldSelectorProps> = (
  props
) => {
  const {
    withSearch,
    searchKeyword,
    onSearchKeyword,
    folders,
    selectedFolder,
    formats,
    selectedFormat,
    isFormatsLoading,
    isFoldersLoading,
    onSelectedFolderChange,
    onSelectedFormatChange,
    className,
    classes,
    searchPlaceholder,
    moduleName,
    headerComponent,
  } = props;

  const searchHeight = 34;
  const searchMargin = 12;

  return (
    <div className={cx("FormatFieldSelector", className)}>
      {withSearch && (
        <Search
          style={{ height: searchHeight, marginBottom: searchMargin }}
          iconProps={getTestAttributes({ id: "btn-ss-format-search-search" })}
          {...getTestAttributes({ id: "tx-ss-format-search-search" })}
          withLiveSearch
          value={searchKeyword}
          placeholder={searchPlaceholder || I18n.t("Search for Spreadsheets")}
          className={cx("FormatFieldSelector__search", classes?.search)}
          classes={{
            searchForm: cx(
              "FormatFieldSelector__search__form",
              classes?.searchForm
            ),
          }}
          onSearch={
            onSearchKeyword
              ? (params: { searchKeyword: string }) =>
                  onSearchKeyword(params.searchKeyword)
              : undefined
          }
        />
      )}
      {headerComponent}
      <Flex
        style={{
          height: `calc(100% - ${
            withSearch ? searchHeight + searchMargin : 0
          }px`,
        }}
      >
        <Folders
          moduleName={moduleName}
          selectedFolder={selectedFolder}
          folders={folders}
          onSelectedFolderChange={onSelectedFolderChange}
          loading={isFoldersLoading}
          className={cx("FormatFieldSelector__folders", classes?.folders)}
        />
        <Formats
          moduleName={moduleName}
          selectedFormat={selectedFormat}
          formats={formats}
          loading={isFormatsLoading}
          onSelectedFormatChange={onSelectedFormatChange}
          className={cx(
            "FormatFieldSelector__formats-fields",
            classes?.formats
          )}
          classes={{
            tableBody: classes?.formatsTableBody,
          }}
        />
      </Flex>
    </div>
  );
};
